import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import { Section, Alert, Main } from '@govhhs/govhhs-design-system-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { AuthenticationActions, CoreReduxStore } from '@spm/core';
import translations from './ErrorBoundaryMessages';
import PATHS from '../router/Paths';
import RouterLink from '../router/RouterLink';
import { ID } from './constants';
import IEGPageNotAvailable from './IEGPageNotAvailable';
/**
 * Handles application errors by parsing the error information and taking the appropriate action.
 * In most cases a message will be displayed to the user, with instructions about
 * what action to take so that they can continue to use the application.
 *
 * @class ErrorBoundaryComponent
 * @extends {Component}
 *
 * @memberof ErrorBoundaryComponent
 */

var ErrorBoundaryComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundaryComponent, _React$Component);

  var _super = _createSuper(ErrorBoundaryComponent);
  /**
   * Creates an instance of ErrorBoundaryComponent.
   *
   * @param {any} props the props for the component
   * @memberof ErrorBoundaryComponent
   */


  function ErrorBoundaryComponent(props) {
    var _this;

    _classCallCheck(this, ErrorBoundaryComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refreshRouterLink", function (text) {
      return /*#__PURE__*/React.createElement(RouterLink, {
        onClick: function onClick(e) {
          e.preventDefault(); // refresh current page from link

          window.location.reload();
        },
        to: PATHS.HOME
      }, text);
    });

    var history = _this.props.history; // on route change, reset the custom error message so as not to block
    // pages from nav bar links being displayed.

    /* eslint-disable no-unused-vars */

    var unregisterListener = history.listen(function (location, action) {
      if (_this.state.errorDetails) {
        _this.setState({
          errorDetails: null
        });
      }
    });
    _this.state = {
      errorDetails: null,
      unregisterListener: unregisterListener
    };
    return _this;
  }
  /**
   * Executed when the component is unmounted.
   *
   * @memberof ErrorBoundaryComponent
   */


  _createClass(ErrorBoundaryComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.unregisterListener();
    }
    /**
     * Returns alert message for an error.
     *
     * @returns The alert message.
     * @memberof ErrorBoundaryComponent
     */

  }, {
    key: "getAlertMessage",
    value: function getAlertMessage() {
      var formatMessage = this.props.intl.formatMessage;
      var _this$props = this.props,
          isHeaderBoundary = _this$props.isHeaderBoundary,
          header = _this$props.header,
          footer = _this$props.footer;
      var _this$state$errorDeta = this.state.errorDetails,
          message = _this$state$errorDeta.message,
          status = _this$state$errorDeta.status,
          timeout = _this$state$errorDeta.timeout,
          messageId = _this$state$errorDeta.messageId;
      /**  Wraps a  text with a WDS Alert component. */

      var alert = function alert(alertMessage) {
        return /*#__PURE__*/React.createElement(Alert, {
          center: true,
          "data-testid": ID.ERROR_BOUNDARY_ALERT_ID,
          dismissable: false,
          id: ID.ERROR_BOUNDARY_ALERT_ID,
          role: "alert",
          text: alertMessage,
          type: "danger"
        });
      };

      var refreshPageLink = this.refreshRouterLink(formatMessage(translations.refreshPageLink));
      var goToHome = /*#__PURE__*/React.createElement(RouterLink, {
        to: PATHS.HOME
      }, formatMessage(translations.errorRedirectHomeLink));
      var alertMessage = ''; // default message

      alertMessage = alert( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, translations.defaultError, {
        values: {
          refreshPageLink: refreshPageLink,
          goToHome: goToHome
        }
      })));

      if (status === 401) {
        // Just returning from the function without handling as 401 needs to display the login page.
        alertMessage = null;
      }

      if (status) {
        if (status === 400 || status === 404) {
          var alertMessages400 = {
            DEFAULT: function DEFAULT() {
              return alert(formatMessage(translations.error400));
            },
            HTTP_400_IEG_PAGE_NOT_AVAILABLE: function HTTP_400_IEG_PAGE_NOT_AVAILABLE() {
              return /*#__PURE__*/React.createElement("div", {
                "data-testid": ID.ERROR_BOUNDARY_ALERT_ID,
                id: ID.ERROR_BOUNDARY_ALERT_ID
              }, /*#__PURE__*/React.createElement(IEGPageNotAvailable, null));
            }
          };
          alertMessage = (alertMessages400[messageId] || alertMessages400.DEFAULT)();
        } else if (status === 403) {
          alertMessage = alert( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, translations.error403, {
            values: {
              homePageLink: /*#__PURE__*/React.createElement(RouterLink, {
                to: PATHS.HOME
              }, formatMessage(translations.errorRedirectHomeLink))
            }
          })));
        }
        /** No status, but there is a timeout property which indicates timeout error. */

      } else if (timeout) {
        alertMessage = alert( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, translations.timeoutError, {
          values: {
            refreshPageLink: refreshPageLink
          }
        }))); // REST API call and message indicates network error (superagent does not translate)
        // Even if it did default message would have to suffice!
      } else if (new RegExp(/Request has been terminated/).test(message)) {
        alertMessage = alert( /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, translations.networkError, {
          values: {
            refreshPageLink: this.refreshRouterLink(formatMessage(translations.refreshPageLinkLowerCase)),
            goToHome: goToHome
          }
        })));
      }

      return alertMessage;
    }
    /**
     * The refresh router Link.
     *
     * @param {string} text link text
     *
     * @memberof ErrorBoundaryComponent
     */

  }, {
    key: "redirectToLogin",

    /**
     * Redirects to login page.
     *
     * @memberof ErrorBoundaryComponent
     */
    value: function redirectToLogin() {
      // Redirecting to login page when 401 error occurred.
      sessionStorage.removeItem('username');
      sessionStorage.removeItem('user_account');
      CoreReduxStore.internalStore.dispatch(AuthenticationActions.logout());
      this.props.history.push(PATHS.LOGIN);
      window.location.reload();
    }
    /**
     * Catches the error that occurred from within another React
     * component within the application.
     *
     * @param {any} error Application error that occurred
     * @param {any} info Error stack trace information
     * @memberof ErrorBoundaryComponent
     */

  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var updatedError = error; // if no error object or empty error object

      if (!error || _Object$keys(error).length === 0) {
        updatedError = new Error();

        if (info) {
          updatedError.stack = info.componentStack;
        }
      } // Need to redirect to login page when 401 occurred.


      if (updatedError.status === 401) {
        this.redirectToLogin();
      }

      this.setState({
        errorDetails: updatedError
      }); // You can also log the error to an error reporting service
      // logErrorToMyService(error, info);
    }
    /**
     * Handles application errors and displays appropriate message to the user.
     *
     * @returns The appropriate error message.
     * @memberof ErrorBoundaryComponent
     */

  }, {
    key: "render",
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;
      var _this$props2 = this.props,
          isHeaderBoundary = _this$props2.isHeaderBoundary,
          header = _this$props2.header,
          footer = _this$props2.footer;

      if (this.state.errorDetails != null) {
        var alertMessage = this.getAlertMessage();
        var errorBoundaryMessage =
        /*#__PURE__*/

        /* eslint-disable-next-line no-restricted-syntax */
        React.createElement(Main, {
          className: "wds-l-main--push-footer"
        }, alertMessage && /*#__PURE__*/React.createElement(Section, {
          ariaLabelledBy: ID.ERROR_BOUNDARY_ALERT_ID
        }, alertMessage)); // if this is the header boundary then render the custom header and footer
        // passed to the boundary else just render the error message as we are on a page in the main
        // component.

        return isHeaderBoundary ? /*#__PURE__*/React.createElement(React.Fragment, null, header, errorBoundaryMessage, footer) : errorBoundaryMessage;
      } // if there are no errors


      return this.props.children;
    }
  }]);

  return ErrorBoundaryComponent;
}(React.Component);

ErrorBoundaryComponent.defaultProps = {
  footer: null,
  header: null,
  isHeaderBoundary: false
};
ErrorBoundaryComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  footer: PropTypes.element,
  header: PropTypes.element,
  history: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  isHeaderBoundary: PropTypes.bool
} : {};
/**
 * Handles application errors by parsing the error information and taking the appropriate action.
 * In most cases a message will be displayed to the user, with instructions about
 * what action to take so that they can continue to use the application. For further information
 * on error boundaries see {@link https://reactjs.org/docs/error-boundaries.html|Error boundaries}
 *
 * @param {string} isHeaderBoundary Indicates whether the child component is an application header component or not.
 * This is optional.
 * @param {React.Component} header Header to display when the `isHeaderBoundary` condition is set.
 */

export default withRouter(injectIntl(ErrorBoundaryComponent));